/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_Cta_TitleInputs */

const en_mk_cmp_page_cta_title = /** @type {(inputs: Mk_Cmp_Page_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want agents that work for the whole company, not just engineering?`)
};

const id_mk_cmp_page_cta_title = /** @type {(inputs: Mk_Cmp_Page_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingin agen yang bekerja untuk seluruh perusahaan, bukan cuma tim engineering?`)
};

/**
* | output |
* | --- |
* | "Want agents that work for the whole company, not just engineering?" |
*
* @param {Mk_Cmp_Page_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_cta_title = /** @type {((inputs?: Mk_Cmp_Page_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_cta_title(inputs)
	return en_mk_cmp_page_cta_title(inputs)
});